import { css } from "@emotion/css"

const TOP_LOGO_HEIGHT = 64

export const styles = {
  root: css`
    display: flex;
    flex-direction: column;
    height: 100%;
  `,
  navList: css`
    list-style: none;
    padding: 0;
    margin-top: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
  `,
  logo: css`
    height: ${TOP_LOGO_HEIGHT}px;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  navItem: css`
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    .sublink {
      padding: 0.625rem var(--spacing-s);
      width: 128px;
      height: 40px;
      border-radius: var(--spacing-xxs);
    }
    :hover {
      > div {
        background-color: var(--primary-main-extra-dark);
      }
    }
  `,
  sublinkBorderDiv: css`
    width: 1px;
    height: 40px;
    margin-right: 14px;
    background-color: var(--white);
  `,
  navLink: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0.625rem var(--spacing-s);
    height: var(--spacing-xxl-4);

    color: var(--white);
    text-decoration: none;
    text-transform: capitalize;
    cursor: pointer;

    .icon {
      > svg {
        width: var(--spacing-xl);
        min-height: var(--spacing-xl);
      }
    }

    .label {
      margin-left: var(--spacing-s);
    }

    :focus {
      outline: none;
    }
    :hover {
      background-color: var(--primary-main-extra-dark);
    }
  `,
  activeNavLink: css`
    background-color: var(--primary-main-extra-dark);
  `,
  expandedActiveNavLink: css`
    .active {
      background-color: var(--primary-main-extra-dark);
      border-radius: var(--spacing-xxs);
    }
  `,
  toggleButton: css`
    cursor: pointer;
    padding: var(--spacing-m) var(--spacing-xs);
    align-self: flex-end;
    margin-top: var(--spacing-xs);
    margin-bottom: var(--spacing-m);
  `,
  mirrored: css`
    transform: rotate(180deg);
  `,
  largeIcon: css`
    width: 32px !important;
    min-height: 32px !important;
    margin-left: -4px;
    color: var(--white);
  `,
  notificationsLabel: css`
    margin-left: var(--spacing-xs) !important ;
    display: flex;
    align-items: center;
    width: -webkit-fill-available;
    width: -moz-available;
  `,
  badge: css`
    display: block;
    > span {
      width: var(--spacing-m);
      min-height: var(--spacing-m);
      font-size: 11px;
      font-weight: 700;
      padding: 0;
      position: absolute;
      transform: none;
      top: -4px;
      right: -2px;
    }
  `,
  unread: css`
    background-color: var(--red);
    padding: var(--spacing-xxs) var(--spacing-xxs);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    margin: 0 0 0 auto;
  `,
  navListAccount: css`
    margin: auto 0 0 0;
    display: flex;
    flex-direction: column-reverse;
    > div {
      align-items: end;
      height: var(--spacing-xxl-5);
    }
  `,
  navItemAvatar: css`
    margin-left: -4px;
    justify-content: center;
  `,
  avatar: css`
    width: var(--spacing-xxl-2);
    height: var(--spacing-xxl-2);
    background-color: var(--secondary-dark-blue);
    text-transform: uppercase;
  `,
  accountDiv: css`
    display: grid;
    grid-row-gap: var(--spacing-xxs);
    text-overflow: ellipsis;
    overflow-x: hidden;
    white-space: nowrap;
    width: 88px;
  `,
  accountName: css`
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  divider: css`
    background-color: var(--white);
    height: 1px;
    opacity: 0.3;
    margin: var(--spacing-xl) var(--spacing-xs) var(--spacing-l);
  `,
  links: css`
    display: flex;
    flex-direction: column;
    align-items: center;

    .linkIcon {
      padding: var(--spacing-xxs);
      cursor: pointer;
      width: 100%;
      display: flex;
      justify-content: center;
      > svg {
        width: 23px;
        height: 24px;
      }
      :hover {
        background-color: var(--primary-main-extra-dark);
      }
    }
  `,
  collapsedLinks: css`
    align-items: flex-start;
  `,
  link: css`
    color: var(--white);
    padding: var(--spacing-xs);
    padding-left: var(--spacing-m);
    width: 100%;
    :hover {
      background-color: var(--primary-main-extra-dark);
      text-decoration: none;
    }
  `,

  // Collapse
  wrapper: css`
    margin: var(--spacing-m) 0 var(--spacing-m) var(--spacing-xl);
  `,
  collapseExpandIcon: css`
    padding: 0;
    margin-left: auto;
    color: var(--white);
    :hover {
      background-color: transparent;
    }
  `,
  collapseExpandedIcon: css`
    transform: rotate(180deg);
  `,
}
